import React from 'react'
import House from '../Work-Assets/w991x660.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faHashtag } from '@fortawesome/free-solid-svg-icons';
import Contacts from './Contacts/Contacts';
import Banners from './Banners';
import Layout from '.././Work-Assets/WhatsApp Image 2025-01-11 at 10.01.18.jpeg';
import Image_Poster from '.././Work-Assets/Web_Images/Image-4.jpeg';
import Web_images from './Web_Images/Web_images';

function Content() {
  return (
    <div className='inner_CONT'>

    <div className='banners_MOTION'><Banners /></div>
    <div className='AD_IMG'>
      <img src={Layout} />
    </div>

      <div className='Who_AW'>Who are We?</div>
     
      <div className='green_CONT'>
        <div className='cont_txt'>
        We are a dedicated student accomodation organization committed to connecting students with their ideal hostels. 
        Managing a diverse portfolio of properties, 
        we ensure that every student finds a comfortable, secure, and convenient place to call home during their academic journey.
       </div>

     
      </div>

      <div className='green_CONT'>

        <div className='cont_txt'>
        <div className='OS'>Our Services?</div>
        Student Recruitment: We simplify the process of finding the perfect hostel by matching students with properties that suit their preferences and needs.

        Follow-Up Services: Our relationship doesn’t end once you move in. We provide continuous support to ensure a smooth stay.

        Support Services: Beyond housing, we care about your overall well-being. Our team offers free guidance and counseling services, fostering a supportive environment to help you thrive.

       </div>

     
      </div>

      <div className='green_CONT'>

<div className='cont_txt'>
<div className='WAW'>Our Motto! Guaranteed Welfare</div>
At Hostel Adventures, we prioritize your comfort, safety, and success. 
Whether you need a serene study environment, proximity to campus, or access to vibrant student life, we are here to make it happen.

Join us and experience a hassle-free journey to finding your ideal hostel. At Hostel Adventures, your welfare is our mission.


</div>


</div>

<div className='web_IMAGES_MAIN'>
  <Web_images />
  <div className='poster_fl'>


<div className='poster_FL_IMG'>
  <img src={Image_Poster} />
</div>

<div className='list'>
  <p className='poster_DES'>Our Services!!</p>
 <div>-accomodation</div>
 <p>-Guidance and counselling</p>
 <p>-Follow up Services</p>
 <p>-Emergency Response</p>
 <p>-Academic Assistance</p>
 <p>-Attachment Assistance</p>
 <p>-Internship Assistance</p>
 <p>-Alumni Networks</p>
 <p>and so on...</p>
</div>


</div>
</div>

<div className='web_image_gap'></div>

<div className='contacts_margin'>
<Contacts />

</div>




    </div>
  )
}

export default Content
